// Routes
import routes from './routes'

export class SubsReportFeature {

  /** @type {RouteConfig} */
  static routes = routes
}
